var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorNumberplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "motor-Number plate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M2 6.6C2 5.33988 2 4.70982 2.24524 4.22852C2.46095 3.80516 2.80516 3.46095 3.22852 3.24524C3.70982 3 4.33988 3 5.6 3H13.4C14.6601 3 15.2902 3 15.7715 3.24524C16.1948 3.46095 16.5391 3.80516 16.7548 4.22852C17 4.70982 17 5.33988 17 6.6V11.4C17 12.6601 17 13.2902 16.7548 13.7715C16.5391 14.1948 16.1948 14.5391 15.7715 14.7548C15.2902 15 14.6601 15 13.4 15H5.6C4.33988 15 3.70982 15 3.22852 14.7548C2.80516 14.5391 2.46095 14.1948 2.24524 13.7715C2 13.2902 2 12.6601 2 11.4V6.6Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12C12.5 11.4477 12.1642 11 11.75 11H4.25C3.83579 11 3.5 11.4477 3.5 12C3.5 12.5523 3.83579 13 4.25 13H11.75C12.1642 13 12.5 12.5523 12.5 12Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7C12.5 6.44772 12.1642 6 11.75 6H4.25C3.83579 6 3.5 6.44772 3.5 7C3.5 7.55228 3.83579 8 4.25 8H11.75C12.1642 8 12.5 7.55228 12.5 7Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6C14.3358 6 14 6.44772 14 7V10C14 10.5523 14.3358 11 14.75 11C15.1642 11 15.5 10.5523 15.5 10V7C15.5 6.44772 15.1642 6 14.75 6Z",
    fill: "#6B47F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorNumberplate);
export default __webpack_public_path__ + "static/media/motor-Number plate.b8877f1707b87ab9e1bd7617c4f12faa.svg";
export { ForwardRef as ReactComponent };